"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports["default"]=_default;function _default(a,b){return!!(b&&b.includes(a))}